import { PUBLIC_LOCATION_STATES as a, PUBLIC_ONLINE_COURSE_STATES as r } from "@coast/utils";
const t = [
  { label: "California", href: "/dmv-practice-test" },
  { label: "Colorado", href: "/dmv-practice-test?state=co" },
  { label: "Nevada", href: "/dmv-practice-test?state=nv" },
  { label: "Texas", href: "/dmv-practice-test?state=tx" }
], i = [
  {
    label: "Permit Practice Tests",
    description: "State-specific questions with instant feedback.",
    href: "/dmv-practice-test",
    badges: t.map((e) => e.label),
    subLinks: t
  },
  {
    label: "How to Get a License",
    description: "Checklists for each state's requirements.",
    href: "/how-to-get-drivers-license"
  },
  {
    label: "Articles",
    description: "Guides on permits, road tests, and car ownership.",
    href: "/articles"
  }
], l = [
  {
    label: "Our Story",
    description: "Meet the team and our mission.",
    href: "/article/about-coastline-academy"
  },
  {
    label: "Reviews",
    description: "Thousands of 5-star student stories.",
    href: "/coastline-academy-driving-school-reviews"
  },
  {
    label: "Contact",
    description: "Reach our support and partnerships team.",
    href: "/contact"
  },
  {
    label: "Careers",
    description: "Help us grow coast-to-coast.",
    href: "/careers"
  }
], c = [
  {
    label: "Locations",
    eyebrow: "Where we teach",
    items: [
      {
        label: "View all",
        description: "Browse every Coastline market.",
        href: "/locations",
        badges: ["All states"]
      },
      ...a.map((e) => ({
        label: e.label,
        description: e.description,
        href: `/state/${e.slug}`
      }))
    ]
  },
  {
    label: "Online Courses",
    eyebrow: "Available in some states",
    items: r.map((e) => ({
      label: e.label,
      description: e.description,
      href: e.courses[0].href,
      badges: e.courses.map((s) => s.badge),
      subLinks: e.courses.map((s) => ({
        label: s.label,
        href: s.href
      }))
    }))
  },
  {
    label: "Schedule Lesson",
    variant: "link",
    items: [
      {
        label: "Schedule Lesson",
        href: "/location-search"
      }
    ]
  },
  {
    label: "Resources",
    eyebrow: "Tools for students",
    variant: "list",
    items: i
  },
  {
    label: "About",
    eyebrow: "Get to know us",
    variant: "list",
    items: l
  }
];
export {
  l as A,
  c as N,
  i as R
};
